module.exports = __webpack_public_path__ + "static/media/logo-white.a5b4f41f.png";